import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityProject } from "../../entity/EntityProject";

export class DtoProjectsGetRes extends EntityProject {
  public items: EntityProject[]  = [];
}
